module.exports = __webpack_public_path__ + "media/images/post/icon_sns_weibo-b62e361e3938d62f9755494e07f5e14b.png";